import React from 'react';
import { Container } from './styles';

export interface PropsInsideForm {
  className?: string;
  ref?: unknown;
  style?: React.CSSProperties;
  children: unknown;
}

const BlockInsideForm: React.FC<PropsInsideForm> = ({
  children,
  className,
  style,
}) => {
  return (
    <Container className={className} style={style}>
      <>{children}</>
    </Container>
  );
};

export default BlockInsideForm;
